<template>
  <Transition name="fade">
    <div class="cookie-section" v-if="!agreePrivacy">
      <div class="left">
        為提供您最佳的網站體驗，裕隆集團官方網站會於網站使用本身或第三方的Cookie，以作為技術、分析或網站優化之用。
        <br />
        當您點擊繼續或繼續瀏覽本網站，即表示您同意我們使用。
      </div>
      <div class="right">
        <MiddleButton white radius @click="handleAgree">繼續</MiddleButton>
      </div>
    </div>
  </Transition>
</template>

<script>
import MiddleButton from "@/components/button/MiddleButton.vue";
import { ref } from "vue";
import VueCookies from "vue-cookies";

export default {
  name: "CookieBox",
  components: {
    MiddleButton,
  },
  setup() {
    const agreePrivacy = ref(false); // 一開始會顯示
    agreePrivacy.value = VueCookies.get("agreePrivacy");
    console.log("agreePrivacy.value", agreePrivacy.value);
    const handleAgree = () => {
      VueCookies.set("agreePrivacy", true);
      agreePrivacy.value = true;
    };
    return {
      handleAgree,
      agreePrivacy,
    };
  },
};
</script>


<style lang="scss" scoped>
.cookie-section {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 2.5rem;
  width: 100%;
  font-size: 14px;
  color: $white;
  background: rgba(0, 0, 0, 0.8);
  z-index: 100;
}
</style>